import isEmpty from 'lodash/isEmpty'
import { Component } from 'preact'
import LinearProgress from 'preact-material-components/LinearProgress'
import { connect } from 'preact-redux'
import { withNamespaces } from 'react-i18next'
import { getAvailableCategories } from '../../modules/availableCategories'
import { getCategories } from '../../modules/categories'
import { getPrices } from '../../modules/prices'
import { changeSecretKey } from '../../modules/secretKey'
import { setShoppingCartDates } from '../../modules/shoppingCart'
import { getProperties } from '../../modules/properties'
import { selectCategories, selectIsFetching } from '../../selectors/categoriesSelector'
import { getUTCTime } from '../../utils'
import Credential from '../Credential'
import ShoppingCart from '../ShoppingCart'
import AvailableCategories from './AvailableCategories'
import styles from './RoomsLayout.scss'
import SearchRoomsForm from './SearchRoomsForm'
import { selectProperties } from '../../selectors/properties'

const mapStateToProps = state => ({
    categories: selectCategories(state),
    isFetching: selectIsFetching(state),
    propertires: selectProperties(state)
})

@connect(
    mapStateToProps,
    { setShoppingCartDates, getAvailableCategories, getCategories, getPrices, changeSecretKey, getProperties }
)
class RoomsLayout extends Component {
    state = {
        showCategories: false
    }

    componentDidMount() {
        this.props.changeSecretKey(this.props.secretKey)
        this.props.getProperties(this.props.secretKey)
    }

    handleSearch = (startDate, endDate) => {
        this.props.setShoppingCartDates(startDate, endDate)

        const timeParams = {
            startTime: getUTCTime(startDate),
            endTime: getUTCTime(endDate)
        }

        this.props.getAvailableCategories(timeParams)
        this.props.getCategories()
        this.props.getPrices(timeParams)

        this.setState({ showCategories: true })
    }

    handleNextClick = () => {
        this.props.onGoNext()
    }

    render({ isFetching, categories, propertires }, { showCategories }) {
        const { t, arrivalUseAlready, departureUseAlready, changeUseDateInfo } = this.props

        const { entities, currentProperty, isFetching: propertiesFetching } = propertires

        return (
            <div class={styles.wrapper}>
                <SearchRoomsForm
                    onSearch={this.handleSearch}
                    properties={entities}
                    currentProperty={currentProperty}
                    isFetching={propertiesFetching}
                    arrivalUseAlready={arrivalUseAlready}
                    departureUseAlready={departureUseAlready}
                    changeUseDateInfo={changeUseDateInfo}
                    startDateDefault={this.props.startDateDefault}
                    endDateDefault={this.props.endDateDefault}
                />

                {showCategories && (
                    <div>
                        {isFetching && (
                            <div class={styles.linearProgress}>
                                <LinearProgress indeterminate />
                            </div>
                        )}

                        {!isEmpty(categories) ? (
                            <div class={styles.roomsLayout}>
                                <div class={styles.rooms}>
                                    {!isFetching && <AvailableCategories categories={categories} />}
                                </div>

                                <div class={styles.shoppingCart}>
                                    <ShoppingCart sticky onNextClick={this.handleNextClick} />
                                </div>
                            </div>
                        ) : (
                            !isFetching && <div class={styles.noFound}>{t('RoomsLayout.nofreerooms')}</div>
                        )}
                    </div>
                )}

                <Credential />
            </div>
        )
    }
}

export default withNamespaces()(RoomsLayout)



// WEBPACK FOOTER //
// ./components/RoomsLayout/RoomsLayout.js